import './../Styles/personioMain.scss'

window.am = window.am || {};

window.am.personioJobAdsMain = new function () {
    const init = () => {
        const personioJobsadMainPositionSpans = document.querySelectorAll('.personio-jobsad-main__position-richtext span');

        personioJobsadMainPositionSpans.forEach((span) => {
            span.removeAttribute('style');
        });

        const personioJobsadMainPositionLis = document.querySelectorAll('.personio-jobsad-main__position-richtext li');

        personioJobsadMainPositionLis.forEach((li) => {
            li.removeAttribute('style');
        });
    };

    return {
        init: init
    };
}

window.addEventListener('load', window.am.personioJobAdsMain.init);